'use strict'

const defaults = require('./en')

module.exports = Object.assign({}, defaults, {
  custom: {
    display_name: {
      required: (value, params) => `กรุณากรอกนามแฝง`,
      max: (value, params) => `นามแฝงสูงสุด ${params[0]} ตัวอักษร`,
      min: (value, params) => `นามแฝงอย่างน้อย ${params[0]} ตัวอักษร`
    },
    mobile: {
      required: (value, params) => `กรุณากรอกหมายเลขโทรศัพท์`,
      numeric: (value, params) => `หมายเลขโทรศัพท์ไม่ถูกต้อง`,
      length: (value, params) => `หมายเลขโทรศัพท์ไม่ถูกต้อง`,
    },
    security_code: {
      required: (value, params) => `กรุณากรอกรหัสความปลอดภัย`,
      numeric: (value, params) => `รหัสความปลอดภัยไม่ถูกต้อง`,
      length: (value, params) => `รหัสความปลอดภัยไม่ถูกต้อง`,
    },
    verify_code: {
      required: (value, params) => `กรุณากรอกรหัสยืนยัน`,
      numeric: (value, params) => `รหัสยืนยันไม่ถูกต้อง`,
      length: (value, params) => `รหัสยืนยันไม่ถูกต้อง`,
    },
    username: {
      required: (value, params) => `กรุณากรอกชื่อผู้ใช้งาน`,
      max: (value, params) => `ชื่อผู้ใช้งานสูงสุด ${params[0]} ตัวอักษร`,
      min: (value, params) => `ชื่อผู้ใช้งานอย่างน้อย ${params[0]} ตัวอักษร`
    },
    password: {
      required: (value, params) => `กรุณากรอกรหัสผ่าน`,
      max: (value, params) => `รหัสผ่านสูงสุด ${params[0]} ตัวอักษร`,
      min: (value, params) => `รหัสผ่านอย่างน้อย ${params[0]} ตัวอักษร`,
      regex: (value, params) => `รหัสผ่านจะต้องประกอบด้วย ตัวอักษร และ ตัวเลข`
    },
    password_confirm: {
      required: (value, params) => `กรุณายืนยันรหัสผ่าน`,
      confirmed: (value, params) => `ยืนยันรหัสผ่านไม่ถูกต้อง`
    },

    new_password: {
      required: (value, params) => `กรุณากรอกรหัสผ่านใหม่`,
      max: (value, params) => `รหัสผ่านสูงสุด ${params[0]} ตัวอักษร`,
      min: (value, params) => `รหัสผ่านอย่างน้อย ${params[0]} ตัวอักษร`,
      regex: (value, params) => `รหัสผ่านจะต้องประกอบด้วย ตัวอักษร และ ตัวเลข`
    },
    new_password_confirm: {
      required: (value, params) => `กรุณายืนยันรหัสผ่าน`,
      confirmed: (value, params) => `ยืนยันรหัสผ่านไม่ถูกต้อง`
    },
    old_password: {
      required: (value, params) => `กรุณากรอกรหัสผ่าน`
    },
    email: {
      required: (value, params) => `กรุณากรอกอีเมล`,
      email: (value, params) => `อีเมลไม่ถูกต้อง`
    },
    bank_number: {
      required: (value, params) => `กรุณากรอกเลขบัญชีธนาคาร`,
      numeric: (value, params) => `เลขบัญชีธนาคารไม่ถูกต้อง`,
      length: (value, params) => `เลขบัญชีธนาคารไม่ถูกต้อง`
    },
    bank_number_confirm: {
      required: (value, params) => `กรุณายืนยันเลขบัญชีธนาคาร`,
      confirmed: (value, params) => `ยืนยันเลขบัญชีธนาคารไม่ถูกต้อง`
    },
    deposit_amount: {
      required: (value, params) => `กรุณากรอกจำนวนเงิน`,
      min_value: (value, params) => `ฝากเงินขั้นต่ำ ${params[0]} บาท`,
      regex: (value, params) => `จำนวนเงินไม่ถูกต้อง`
    },
    withdraw_amount: {
      required: (value, params) => `กรุณากรอกจำนวนเงิน`,
      min_value: (value, params) => `ถอนเงินขั้นต่ำ ${params[0]} บาท`
    }
  },
  messages: {
  }
})
